import React from "react";
import { Box, Typography } from "@mui/material";
import { colorPrimary, colorOrange } from "../../Styles/Colors";

const VARIANT_COLOR_MAP = {
  high: { color: "#e53935", label: "High" },
  medium: { color: colorOrange, label: "Medium" },
  low: { color: "#388e3c", label: "Low" },
};

const StatusLinearProgressBar = ({
  variant = "medium",
  value = 50,
  width = 320,
  height = "4px",
  bgColor = "#eee",
  borderColor = "#b39ddb",
  style = {},
  ...props
}) => {
  const variantInfo = VARIANT_COLOR_MAP[variant] || {};
  const barColor = variantInfo.color || "#888";
  const barLabel = variantInfo.label || variant;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "left", 
        width: 480,
        gap: "15px",
        ...style,
      }}
      {...props}
    >
      <Box sx={{   display: "flex", flexDirection: "column", gap: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: width,
              height: height,
              background: bgColor,
              borderRadius: 4,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: `${value}%`,
                height: "100%",
                background: barColor,
                borderRadius: 4,
                position: "absolute",
                left: 0,
                top: 0,
                transition: "width 0.5s",
              }}
            />
          </Box>
        </Box>
      </Box>

      <Typography variant="body2" sx={{ color: "#222", fontSize: 14 }}>
        {barLabel}
      </Typography>
    </Box>
  );
};

export default StatusLinearProgressBar;
